import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterOrders",
  pure: false,
})
export class FilterOrdersPipe implements PipeTransform {
  transform(orders: any[], searchData: string = ""): any[] {
    if (!searchData.trim()) {
      return orders;
    }

    return orders.filter((order: any) => {
      return order.id.toString() === searchData.trim();
      //return order.id.toString().includes(searchData.trim());
    });
  }
}
